import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import IndividualFundingStep from '../../loan-application/steps/IndividualFundingStep';
import { quoteMatches } from '../../../services/individualPricingQuotations';
import { affordabilityError, requoteIndividualApplication } from '../../../services/individualAffordability';

/** Reuses individual request capture; only an explicitly selected quotation is persisted. */
export default function IndividualAffordabilityRequotation({ application, onApplied }: {
  application: any; onApplied: () => void;
}) {
  const f = application.financialDetails || {};
  const methods = useForm({ defaultValues: {
    individual: { idNumber: application.individual?.idNumber || '',
      monthlyNetIncome: f.income?.netIncome, monthlyLivingExpenses: f.livingExpenses },
    financial: f,
    loan: { ...application.loanDetails, individualPricingQuote: undefined as any }
  } });
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const loan = methods.watch('loan');
  const quote = loan.individualPricingQuote;
  return <div className="mt-3">
    <button type="button" className="btn btn-outline-primary" disabled={busy} aria-expanded={open}
      onClick={() => { setError(''); setOpen(value => !value); }}>
      {open ? 'Close revised request' : 'Revise individual loan quotation'}
    </button>
    {open && <FormProvider {...methods}><div className="border rounded p-3 mt-2">
      <p>Current request: R {Number(application.loanDetails?.loanAmount).toFixed(2)}, {application.loanDetails?.numberOfInstallments} instalment(s), due {application.loanDetails?.dueDate}.</p>
      <p>Select a new retained quotation, then apply it explicitly. Previous quotation and assessment records are retained. Verified affordability and the analyst recommendation must be completed again.</p>
      <fieldset disabled={busy}>
      <IndividualFundingStep showDefaultTerms={false} />
      <button type="button" className="btn btn-primary mt-3" disabled={busy || !quoteMatches(quote, loan)} onClick={async () => {
        setBusy(true); setError('');
        try { await requoteIndividualApplication(application.id, quote.quoteId); setOpen(false); onApplied(); }
        catch (failure) { setError(affordabilityError(failure)); }
        finally { setBusy(false); }
      }}>{busy ? 'Applying quotation…' : 'Apply revised quotation and reassess'}</button>
      </fieldset>
      {error && <p role="alert" className="text-danger mt-2">{error}</p>}
    </div></FormProvider>}
  </div>;
}
